// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"5f998a92","366":"83da5029","503":"11226c19","846":"951ef999"}[chunkId] + ".chunk.js";
};